export const CUSTOM_TRACK_TITLE = 'Custom Track';
export const CUSTOM_TRACK_VALUE = 'CUSTOM_TRACK';

const colors: { [key: string]: string } = {
    PRIMARY_01: '#315CD5',
    TALENT_POOL: '#F2F7FD',
    PRE_VETTED: '#EAEAEA',
    VETTED: '#F7ECF1',
    INTERVIEW: '#DEE8ED',
    FINALIZED: '#E5F6E8',
    SEND_REMINDER: '#308CC1',
    VIEW_CANDIDATE_PERFORMANCE: '#498280',
    FINALISE: '#27AE60',
    REJECTED: '#F2DBD3',
    REJECT: '#ef794a',
    REMOVE_CANDIDATE: '#EB5757',
    CANDIDATE_INFO_BORDER: '#eed8e2',
    MOVE_CANDIDATE: "#1F4388",
    MORE_OPTION_BUTTON: "#6C757D",
    ADD_COMMENT: '#F88713',
    PROGRESS_00: '#DEE7F8',
    PROGRESS_01: '#80C7E9',
    PROGRESS_02: '#009D9A',
    PROGRESS_03: '#6929C4',
    PROGRESS_04: '#F2C94C',
    PROGRESS_05: '#1EDE40',
};

export const messages = {
    SEND_INTERVIEW_REQUEST: 'Send Inteview Request',
    SEND_REMINDER: 'Send Reminder',
    FINALISE: 'Finalise',
    REJECT: 'Reject',
    VIEW_CANDIDATE_PERFORMANCE: 'Detailed Analysis',
    PRE_VETTED_CANDIDATE: 'Engage Candidate',
    FAST_TRACK: 'Fast Forward',
    REMOVE_CANDIDATE: 'Remove Candidate',
    ADD_COMMENT: 'Add Comment',
    MOVE_CANDIDATE: 'Move Candidate To Diffrent State',
    SCHEDULE_MEETING: "Schedule Meeting For Candidate",
    SEND_CUSTOM_REMINDER: "Send Custom Reminder",
    DOWNLOAD_RESUME: "Download Resume",
    UPLOAD_RESUME: "Upload Resume",
}

export const DEFAULT_EQUITY_VALUE = 0;

export const compensationOptions = [
    { key: 'CASH_ANDOR_EQUITY', label: 'Cash &/or Equity', value: 0 },
    { key: 'ONLY_EQUITY', label: 'Only Equity', value: 1 },
]

export const theme = { colors };

export const timeArray = [
    { key: "12:00 AM", label: "12:00 AM" },
    { key: "12:30 AM", label: "12:30 AM" },
    { key: "01:00 AM", label: "01:00 AM" },
    { key: "01:30 AM", label: "01:30 AM" },
    { key: "02:00 AM", label: "02:00 AM" },
    { key: "02:30 AM", label: "02:30 AM" },
    { key: "03:00 AM", label: "03:00 AM" },
    { key: "03:30 AM", label: "03:30 AM" },
    { key: "04:00 AM", label: "04:00 AM" },
    { key: "04:30 AM", label: "04:30 AM" },
    { key: "05:00 AM", label: "05:00 AM" },
    { key: "05:30 AM", label: "05:30 AM" },
    { key: "06:00 AM", label: "06:00 AM" },
    { key: "06:30 AM", label: "06:30 AM" },
    { key: "07:00 AM", label: "07:00 AM" },
    { key: "07:30 AM", label: "07:30 AM" },
    { key: "08:00 AM", label: "08:00 AM" },
    { key: "08:30 AM", label: "08:30 AM" },
    { key: "09:00 AM", label: "09:00 AM" },
    { key: "09:30 AM", label: "09:30 AM" },
    { key: "10:00 AM", label: "10:00 AM" },
    { key: "10:30 AM", label: "10:30 AM" },
    { key: "11:00 AM", label: "11:00 AM" },
    { key: "11:30 AM", label: "11:30 AM" },
    { key: "12:00 PM", label: "12:00 PM" },
    { key: "12:30 PM", label: "12:30 PM" },
    { key: "01:00 PM", label: "01:00 PM" },
    { key: "01:30 PM", label: "01:30 PM" },
    { key: "02:00 PM", label: "02:00 PM" },
    { key: "02:30 PM", label: "02:30 PM" },
    { key: "03:00 PM", label: "03:00 PM" },
    { key: "03:30 PM", label: "03:30 PM" },
    { key: "04:00 PM", label: "04:00 PM" },
    { key: "04:30 PM", label: "04:30 PM" },
    { key: "05:00 PM", label: "05:00 PM" },
    { key: "05:30 PM", label: "05:30 PM" },
    { key: "06:00 PM", label: "06:00 PM" },
    { key: "06:30 PM", label: "06:30 PM" },
    { key: "07:00 PM", label: "07:00 PM" },
    { key: "07:30 PM", label: "07:30 PM" },
    { key: "08:00 PM", label: "08:00 PM" },
    { key: "08:30 PM", label: "08:30 PM" },
    { key: "09:00 PM", label: "09:00 PM" },
    { key: "09:30 PM", label: "09:30 PM" },
    { key: "10:00 PM", label: "10:00 PM" },
    { key: "10:30 PM", label: "10:30 PM" },
    { key: "11:00 PM", label: "11:00 PM" },
    { key: "11:30 PM", label: "11:30 PM" }
];


export const timeZones = ["Africa/Abidjan", "Africa/Accra", "Africa/Addis_Ababa", "Africa/Algiers", "Africa/Asmara", "Africa/Asmera", "Africa/Bamako", "Africa/Bangui", "Africa/Banjul", "Africa/Bissau", "Africa/Blantyre", "Africa/Brazzaville", "Africa/Bujumbura", "Africa/Cairo", "Africa/Casablanca", "Africa/Ceuta", "Africa/Conakry", "Africa/Dakar", "Africa/Dar_es_Salaam", "Africa/Djibouti", "Africa/Douala", "Africa/El_Aaiun", "Africa/Freetown", "Africa/Gaborone", "Africa/Harare", "Africa/Johannesburg", "Africa/Juba", "Africa/Kampala", "Africa/Khartoum", "Africa/Kigali", "Africa/Kinshasa", "Africa/Lagos", "Africa/Libreville", "Africa/Lome", "Africa/Luanda", "Africa/Lubumbashi", "Africa/Lusaka", "Africa/Malabo", "Africa/Maputo", "Africa/Maseru", "Africa/Mbabane", "Africa/Mogadishu", "Africa/Monrovia", "Africa/Nairobi", "Africa/Ndjamena", "Africa/Niamey", "Africa/Nouakchott", "Africa/Ouagadougou", "Africa/Porto-Novo", "Africa/Sao_Tome", "Africa/Timbuktu", "Africa/Tripoli", "Africa/Tunis", "Africa/Windhoek", "America/Adak", "America/Anchorage", "America/Anguilla", "America/Antigua", "America/Araguaina", "America/Argentina/Buenos_Aires", "America/Argentina/Catamarca", "America/Argentina/ComodRivadavia", "America/Argentina/Cordoba", "America/Argentina/Jujuy", "America/Argentina/La_Rioja", "America/Argentina/Mendoza", "America/Argentina/Rio_Gallegos", "America/Argentina/Salta", "America/Argentina/San_Juan", "America/Argentina/San_Luis", "America/Argentina/Tucuman", "America/Argentina/Ushuaia", "America/Aruba", "America/Asuncion", "America/Atikokan", "America/Atka", "America/Bahia", "America/Bahia_Banderas", "America/Barbados", "America/Belem", "America/Belize", "America/Blanc-Sablon", "America/Boa_Vista", "America/Bogota", "America/Boise", "America/Buenos_Aires", "America/Cambridge_Bay", "America/Campo_Grande", "America/Cancun", "America/Caracas", "America/Catamarca", "America/Cayenne", "America/Cayman", "America/Chicago", "America/Chihuahua", "America/Coral_Harbour", "America/Cordoba", "America/Costa_Rica", "America/Creston", "America/Cuiaba", "America/Curacao", "America/Danmarkshavn", "America/Dawson", "America/Dawson_Creek", "America/Denver", "America/Detroit", "America/Dominica", "America/Edmonton", "America/Eirunepe", "America/El_Salvador", "America/Ensenada", "America/Fort_Nelson", "America/Fort_Wayne", "America/Fortaleza", "America/Glace_Bay", "America/Godthab", "America/Goose_Bay", "America/Grand_Turk", "America/Grenada", "America/Guadeloupe", "America/Guatemala", "America/Guayaquil", "America/Guyana", "America/Halifax", "America/Havana", "America/Hermosillo", "America/Indiana/Indianapolis", "America/Indiana/Knox", "America/Indiana/Marengo", "America/Indiana/Petersburg", "America/Indiana/Tell_City", "America/Indiana/Vevay", "America/Indiana/Vincennes", "America/Indiana/Winamac", "America/Indianapolis", "America/Inuvik", "America/Iqaluit", "America/Jamaica", "America/Jujuy", "America/Juneau", "America/Kentucky/Louisville", "America/Kentucky/Monticello", "America/Knox_IN", "America/Kralendijk", "America/La_Paz", "America/Lima", "America/Los_Angeles", "America/Louisville", "America/Lower_Princes", "America/Maceio", "America/Managua", "America/Manaus", "America/Marigot", "America/Martinique", "America/Matamoros", "America/Mazatlan", "America/Mendoza", "America/Menominee", "America/Merida", "America/Metlakatla", "America/Mexico_City", "America/Miquelon", "America/Moncton", "America/Monterrey", "America/Montevideo", "America/Montreal", "America/Montserrat", "America/Nassau", "America/New_York", "America/Nipigon", "America/Nome", "America/Noronha", "America/North_Dakota/Beulah", "America/North_Dakota/Center", "America/North_Dakota/New_Salem", "America/Nuuk", "America/Ojinaga", "America/Panama", "America/Pangnirtung", "America/Paramaribo", "America/Phoenix", "America/Port-au-Prince", "America/Port_of_Spain", "America/Porto_Acre", "America/Porto_Velho", "America/Puerto_Rico", "America/Punta_Arenas", "America/Rainy_River", "America/Rankin_Inlet", "America/Recife", "America/Regina", "America/Resolute", "America/Rio_Branco", "America/Rosario", "America/Santa_Isabel", "America/Santarem", "America/Santiago", "America/Santo_Domingo", "America/Sao_Paulo", "America/Scoresbysund", "America/Shiprock", "America/Sitka", "America/St_Barthelemy", "America/St_Johns", "America/St_Kitts", "America/St_Lucia", "America/St_Thomas", "America/St_Vincent", "America/Swift_Current", "America/Tegucigalpa", "America/Thule", "America/Thunder_Bay", "America/Tijuana", "America/Toronto", "America/Tortola", "America/Vancouver", "America/Virgin", "America/Whitehorse", "America/Winnipeg", "America/Yakutat", "America/Yellowknife", "Antarctica/Casey", "Antarctica/Davis", "Antarctica/DumontDUrville", "Antarctica/Macquarie", "Antarctica/Mawson", "Antarctica/McMurdo", "Antarctica/Palmer", "Antarctica/Rothera", "Antarctica/South_Pole", "Antarctica/Syowa", "Antarctica/Troll", "Antarctica/Vostok", "Arctic/Longyearbyen", "Asia/Aden", "Asia/Almaty", "Asia/Amman", "Asia/Anadyr", "Asia/Aqtau", "Asia/Aqtobe", "Asia/Ashgabat", "Asia/Ashkhabad", "Asia/Atyrau", "Asia/Baghdad", "Asia/Bahrain", "Asia/Baku", "Asia/Bangkok", "Asia/Barnaul", "Asia/Beirut", "Asia/Bishkek", "Asia/Brunei", "Asia/Calcutta", "Asia/Chita", "Asia/Choibalsan", "Asia/Chongqing", "Asia/Chungking", "Asia/Colombo", "Asia/Dacca", "Asia/Damascus", "Asia/Dhaka", "Asia/Dili", "Asia/Dubai", "Asia/Dushanbe", "Asia/Famagusta", "Asia/Gaza", "Asia/Harbin", "Asia/Hebron", "Asia/Ho_Chi_Minh", "Asia/Hong_Kong", "Asia/Hovd", "Asia/Irkutsk", "Asia/Istanbul", "Asia/Jakarta", "Asia/Jayapura", "Asia/Jerusalem", "Asia/Kabul", "Asia/Kamchatka", "Asia/Karachi", "Asia/Kashgar", "Asia/Kathmandu", "Asia/Katmandu", "Asia/Khandyga", "Asia/Kolkata", "Asia/Krasnoyarsk", "Asia/Kuala_Lumpur", "Asia/Kuching", "Asia/Kuwait", "Asia/Macao", "Asia/Macau", "Asia/Magadan", "Asia/Makassar", "Asia/Manila", "Asia/Muscat", "Asia/Nicosia", "Asia/Novokuznetsk", "Asia/Novosibirsk", "Asia/Omsk", "Asia/Oral", "Asia/Phnom_Penh", "Asia/Pontianak", "Asia/Pyongyang", "Asia/Qatar", "Asia/Qostanay", "Asia/Qyzylorda", "Asia/Rangoon", "Asia/Riyadh", "Asia/Saigon", "Asia/Sakhalin", "Asia/Samarkand", "Asia/Seoul", "Asia/Shanghai", "Asia/Singapore", "Asia/Srednekolymsk", "Asia/Taipei", "Asia/Tashkent", "Asia/Tbilisi", "Asia/Tehran", "Asia/Tel_Aviv", "Asia/Thimbu", "Asia/Thimphu", "Asia/Tokyo", "Asia/Tomsk", "Asia/Ujung_Pandang", "Asia/Ulaanbaatar", "Asia/Ulan_Bator", "Asia/Urumqi", "Asia/Ust-Nera", "Asia/Vientiane", "Asia/Vladivostok", "Asia/Yakutsk", "Asia/Yangon", "Asia/Yekaterinburg", "Asia/Yerevan", "Atlantic/Azores", "Atlantic/Bermuda", "Atlantic/Canary", "Atlantic/Cape_Verde", "Atlantic/Faeroe", "Atlantic/Faroe", "Atlantic/Jan_Mayen", "Atlantic/Madeira", "Atlantic/Reykjavik", "Atlantic/South_Georgia", "Atlantic/St_Helena", "Atlantic/Stanley", "Australia/ACT", "Australia/Adelaide", "Australia/Brisbane", "Australia/Broken_Hill", "Australia/Canberra", "Australia/Currie", "Australia/Darwin", "Australia/Eucla", "Australia/Hobart", "Australia/LHI", "Australia/Lindeman", "Australia/Lord_Howe", "Australia/Melbourne", "Australia/NSW", "Australia/North", "Australia/Perth", "Australia/Queensland", "Australia/South", "Australia/Sydney", "Australia/Tasmania", "Australia/Victoria", "Australia/West", "Australia/Yancowinna", "Brazil/Acre", "Brazil/DeNoronha", "Brazil/East", "Brazil/West", "CET", "CST6CDT", "Canada/Atlantic", "Canada/Central", "Canada/Eastern", "Canada/Mountain", "Canada/Newfoundland", "Canada/Pacific", "Canada/Saskatchewan", "Canada/Yukon", "Chile/Continental", "Chile/EasterIsland", "Cuba", "EET", "EST", "EST5EDT", "Egypt", "Eire", "Etc/GMT", "Etc/GMT+0", "Etc/GMT+1", "Etc/GMT+10", "Etc/GMT+11", "Etc/GMT+12", "Etc/GMT+2", "Etc/GMT+3", "Etc/GMT+4", "Etc/GMT+5", "Etc/GMT+6", "Etc/GMT+7", "Etc/GMT+8", "Etc/GMT+9", "Etc/GMT-0", "Etc/GMT-1", "Etc/GMT-10", "Etc/GMT-11", "Etc/GMT-12", "Etc/GMT-13", "Etc/GMT-14", "Etc/GMT-2", "Etc/GMT-3", "Etc/GMT-4", "Etc/GMT-5", "Etc/GMT-6", "Etc/GMT-7", "Etc/GMT-8", "Etc/GMT-9", "Etc/GMT0", "Etc/Greenwich", "Etc/UCT", "Etc/UTC", "Etc/Universal", "Etc/Zulu", "Europe/Amsterdam", "Europe/Andorra", "Europe/Astrakhan", "Europe/Athens", "Europe/Belfast", "Europe/Belgrade", "Europe/Berlin", "Europe/Bratislava", "Europe/Brussels", "Europe/Bucharest", "Europe/Budapest", "Europe/Busingen", "Europe/Chisinau", "Europe/Copenhagen", "Europe/Dublin", "Europe/Gibraltar", "Europe/Guernsey", "Europe/Helsinki", "Europe/Isle_of_Man", "Europe/Istanbul", "Europe/Jersey", "Europe/Kaliningrad", "Europe/Kiev", "Europe/Kirov", "Europe/Lisbon", "Europe/Ljubljana", "Europe/London", "Europe/Luxembourg", "Europe/Madrid", "Europe/Malta", "Europe/Mariehamn", "Europe/Minsk", "Europe/Monaco", "Europe/Moscow", "Europe/Nicosia", "Europe/Oslo", "Europe/Paris", "Europe/Podgorica", "Europe/Prague", "Europe/Riga", "Europe/Rome", "Europe/Samara", "Europe/San_Marino", "Europe/Sarajevo", "Europe/Saratov", "Europe/Simferopol", "Europe/Skopje", "Europe/Sofia", "Europe/Stockholm", "Europe/Tallinn", "Europe/Tirane", "Europe/Tiraspol", "Europe/Ulyanovsk", "Europe/Uzhgorod", "Europe/Vaduz", "Europe/Vatican", "Europe/Vienna", "Europe/Vilnius", "Europe/Volgograd", "Europe/Warsaw", "Europe/Zagreb", "Europe/Zaporozhye", "Europe/Zurich", "GB", "GB-Eire", "GMT", "GMT+0", "GMT-0", "GMT0", "Greenwich", "HST", "Hongkong", "Iceland", "Indian/Antananarivo", "Indian/Chagos", "Indian/Christmas", "Indian/Cocos", "Indian/Comoro", "Indian/Kerguelen", "Indian/Mahe", "Indian/Maldives", "Indian/Mauritius", "Indian/Mayotte", "Indian/Reunion", "Iran", "Israel", "Jamaica", "Japan", "Kwajalein", "Libya", "MET", "MST", "MST7MDT", "Mexico/BajaNorte", "Mexico/BajaSur", "Mexico/General", "NZ", "NZ-CHAT", "Navajo", "PRC", "PST8PDT", "Pacific/Apia", "Pacific/Auckland", "Pacific/Bougainville", "Pacific/Chatham", "Pacific/Chuuk", "Pacific/Easter", "Pacific/Efate", "Pacific/Enderbury", "Pacific/Fakaofo", "Pacific/Fiji", "Pacific/Funafuti", "Pacific/Galapagos", "Pacific/Gambier", "Pacific/Guadalcanal", "Pacific/Guam", "Pacific/Honolulu", "Pacific/Johnston", "Pacific/Kiritimati", "Pacific/Kosrae", "Pacific/Kwajalein", "Pacific/Majuro", "Pacific/Marquesas", "Pacific/Midway", "Pacific/Nauru", "Pacific/Niue", "Pacific/Norfolk", "Pacific/Noumea", "Pacific/Pago_Pago", "Pacific/Palau", "Pacific/Pitcairn", "Pacific/Pohnpei", "Pacific/Ponape", "Pacific/Port_Moresby", "Pacific/Rarotonga", "Pacific/Saipan", "Pacific/Samoa", "Pacific/Tahiti", "Pacific/Tarawa", "Pacific/Tongatapu", "Pacific/Truk", "Pacific/Wake", "Pacific/Wallis", "Pacific/Yap", "Poland", "Portugal", "ROC", "ROK", "Singapore", "Turkey", "UCT", "US/Alaska", "US/Aleutian", "US/Arizona", "US/Central", "US/East-Indiana", "US/Eastern", "US/Hawaii", "US/Indiana-Starke", "US/Michigan", "US/Mountain", "US/Pacific", "US/Samoa", "UTC", "Universal", "W-SU", "WET", "Zulu"]

 export const time_Zones = [
    "Africa/Abidjan (GMT) (+0:00)",
    "Africa/Accra (GMT) (+0:00)",
    "Africa/Addis Ababa (EAT) (+3:00)",
    "Africa/Algiers (CET) (+1:00)",
    "Africa/Asmara (EAT) (+3:00)",
    "Africa/Asmera (EAT) (+3:00)",
    "Africa/Bamako (GMT) (+0:00)",
    "Africa/Bangui (WAT) (+1:00)",
    "Africa/Banjul (GMT) (+0:00)",
    "Africa/Bissau (GMT) (+0:00)",
    "Africa/Blantyre (CAT) (+2:00)",
    "Africa/Brazzaville (WAT) (+1:00)",
    "Africa/Bujumbura (CAT) (+2:00)",
    "Africa/Cairo (EET) (+2:00)",
    "Africa/Casablanca (+01) (+1:00)",
    "Africa/Ceuta (CEST) (+2:00)",
    "Africa/Conakry (GMT) (+0:00)",
    "Africa/Dakar (GMT) (+0:00)",
    "Africa/Dar es Salaam (EAT) (+3:00)",
    "Africa/Djibouti (EAT) (+3:00)",
    "Africa/Douala (WAT) (+1:00)",
    "Africa/El Aaiun (+01) (+1:00)",
    "Africa/Freetown (GMT) (+0:00)",
    "Africa/Gaborone (CAT) (+2:00)",
    "Africa/Harare (CAT) (+2:00)",
    "Africa/Johannesburg (SAST) (+2:00)",
    "Africa/Juba (CAT) (+2:00)",
    "Africa/Kampala (EAT) (+3:00)",
    "Africa/Khartoum (CAT) (+2:00)",
    "Africa/Kigali (CAT) (+2:00)",
    "Africa/Kinshasa (WAT) (+1:00)",
    "Africa/Lagos (WAT) (+1:00)",
    "Africa/Libreville (WAT) (+1:00)",
    "Africa/Lome (GMT) (+0:00)",
    "Africa/Luanda (WAT) (+1:00)",
    "Africa/Lubumbashi (CAT) (+2:00)",
    "Africa/Lusaka (CAT) (+2:00)",
    "Africa/Malabo (WAT) (+1:00)",
    "Africa/Maputo (CAT) (+2:00)",
    "Africa/Maseru (SAST) (+2:00)",
    "Africa/Mbabane (SAST) (+2:00)",
    "Africa/Mogadishu (EAT) (+3:00)",
    "Africa/Monrovia (GMT) (+0:00)",
    "Africa/Nairobi (EAT) (+3:00)",
    "Africa/Ndjamena (WAT) (+1:00)",
    "Africa/Niamey (WAT) (+1:00)",
    "Africa/Nouakchott (GMT) (+0:00)",
    "Africa/Ouagadougou (GMT) (+0:00)",
    "Africa/Porto-Novo (WAT) (+1:00)",
    "Africa/Sao Tome (GMT) (+0:00)",
    "Africa/Timbuktu (GMT) (+0:00)",
    "Africa/Tripoli (EET) (+2:00)",
    "Africa/Tunis (CET) (+1:00)",
    "Africa/Windhoek (CAT) (+2:00)",
    "America/Adak (HDT) (-9:00)",
    "America/Anchorage (AKDT) (-8:00)",
    "America/Anguilla (AST) (-4:00)",
    "America/Antigua (AST) (-4:00)",
    "America/Araguaina (-03) (-3:00)",
    "America/Argentina/Buenos Aires (-03) (-3:00)",
    "America/Argentina/Catamarca (-03) (-3:00)",
    "America/Argentina/ComodRivadavia (-03) (-3:00)",
    "America/Argentina/Cordoba (-03) (-3:00)",
    "America/Argentina/Jujuy (-03) (-3:00)",
    "America/Argentina/La Rioja (-03) (-3:00)",
    "America/Argentina/Mendoza (-03) (-3:00)",
    "America/Argentina/Rio Gallegos (-03) (-3:00)",
    "America/Argentina/Salta (-03) (-3:00)",
    "America/Argentina/San Juan (-03) (-3:00)",
    "America/Argentina/San Luis (-03) (-3:00)",
    "America/Argentina/Tucuman (-03) (-3:00)",
    "America/Argentina/Ushuaia (-03) (-3:00)",
    "America/Aruba (AST) (-4:00)",
    "America/Asuncion (-04) (-4:00)",
    "America/Atikokan (EST) (-5:00)",
    "America/Atka (HDT) (-9:00)",
    "America/Bahia (-03) (-3:00)",
    "America/Bahia Banderas (CST) (-6:00)",
    "America/Barbados (AST) (-4:00)",
    "America/Belem (-03) (-3:00)",
    "America/Belize (CST) (-6:00)",
    "America/Blanc-Sablon (AST) (-4:00)",
    "America/Boa Vista (-04) (-4:00)",
    "America/Bogota (-05) (-5:00)",
    "America/Boise (MDT) (-6:00)",
    "America/Buenos Aires (-03) (-3:00)",
    "America/Cambridge Bay (MDT) (-6:00)",
    "America/Campo Grande (-04) (-4:00)",
    "America/Cancun (EST) (-5:00)",
    "America/Caracas (-04) (-4:00)",
    "America/Catamarca (-03) (-3:00)",
    "America/Cayenne (-03) (-3:00)",
    "America/Cayman (EST) (-5:00)",
    "America/Chicago (CDT) (-5:00)",
    "America/Chihuahua (CST) (-6:00)",
    "America/Ciudad Juarez (MDT) (-6:00)",
    "America/Coral Harbour (EST) (-5:00)",
    "America/Cordoba (-03) (-3:00)",
    "America/Costa Rica (CST) (-6:00)",
    "America/Creston (MST) (-7:00)",
    "America/Cuiaba (-04) (-4:00)",
    "America/Curacao (AST) (-4:00)",
    "America/Danmarkshavn (GMT) (+0:00)",
    "America/Dawson (MST) (-7:00)",
    "America/Dawson Creek (MST) (-7:00)",
    "America/Denver (MDT) (-6:00)",
    "America/Detroit (EDT) (-4:00)",
    "America/Dominica (AST) (-4:00)",
    "America/Edmonton (MDT) (-6:00)",
    "America/Eirunepe (-05) (-5:00)",
    "America/El Salvador (CST) (-6:00)",
    "America/Ensenada (PDT) (-7:00)",
    "America/Fort Nelson (MST) (-7:00)",
    "America/Fort Wayne (EDT) (-4:00)",
    "America/Fortaleza (-03) (-3:00)",
    "America/Glace Bay (ADT) (-3:00)",
    "America/Godthab (-01) (-1:00)",
    "America/Goose Bay (ADT) (-3:00)",
    "America/Grand Turk (EDT) (-4:00)",
    "America/Grenada (AST) (-4:00)",
    "America/Guadeloupe (AST) (-4:00)",
    "America/Guatemala (CST) (-6:00)",
    "America/Guayaquil (-05) (-5:00)",
    "America/Guyana (-04) (-4:00)",
    "America/Halifax (ADT) (-3:00)",
    "America/Havana (CDT) (-4:00)",
    "America/Hermosillo (MST) (-7:00)",
    "America/Indiana/Indianapolis (EDT) (-4:00)",
    "America/Indiana/Knox (CDT) (-5:00)",
    "America/Indiana/Marengo (EDT) (-4:00)",
    "America/Indiana/Petersburg (EDT) (-4:00)",
    "America/Indiana/Tell City (CDT) (-5:00)",
    "America/Indiana/Vevay (EDT) (-4:00)",
    "America/Indiana/Vincennes (EDT) (-4:00)",
    "America/Indiana/Winamac (EDT) (-4:00)",
    "America/Indianapolis (EDT) (-4:00)",
    "America/Inuvik (MDT) (-6:00)",
    "America/Iqaluit (EDT) (-4:00)",
    "America/Jamaica (EST) (-5:00)",
    "America/Jujuy (-03) (-3:00)",
    "America/Juneau (AKDT) (-8:00)",
    "America/Kentucky/Louisville (EDT) (-4:00)",
    "America/Kentucky/Monticello (EDT) (-4:00)",
    "America/Knox IN (CDT) (-5:00)",
    "America/Kralendijk (AST) (-4:00)",
    "America/La Paz (-04) (-4:00)",
    "America/Lima (-05) (-5:00)",
    "America/Los Angeles (PDT) (-7:00)",
    "America/Louisville (EDT) (-4:00)",
    "America/Lower Princes (AST) (-4:00)",
    "America/Maceio (-03) (-3:00)",
    "America/Managua (CST) (-6:00)",
    "America/Manaus (-04) (-4:00)",
    "America/Marigot (AST) (-4:00)",
    "America/Martinique (AST) (-4:00)",
    "America/Matamoros (CDT) (-5:00)",
    "America/Mazatlan (MST) (-7:00)",
    "America/Mendoza (-03) (-3:00)",
    "America/Menominee (CDT) (-5:00)",
    "America/Merida (CST) (-6:00)",
    "America/Metlakatla (AKDT) (-8:00)",
    "America/Mexico City (CST) (-6:00)",
    "America/Miquelon (-02) (-2:00)",
    "America/Moncton (ADT) (-3:00)",
    "America/Monterrey (CST) (-6:00)",
    "America/Montevideo (-03) (-3:00)",
    "America/Montreal (EDT) (-4:00)",
    "America/Montserrat (AST) (-4:00)",
    "America/Nassau (EDT) (-4:00)",
    "America/New York (EDT) (-4:00)",
    "America/Nipigon (EDT) (-4:00)",
    "America/Nome (AKDT) (-8:00)",
    "America/Noronha (-02) (-2:00)",
    "America/North Dakota/Beulah (CDT) (-5:00)",
    "America/North Dakota/Center (CDT) (-5:00)",
    "America/North Dakota/New Salem (CDT) (-5:00)",
    "America/Nuuk (-01) (-1:00)",
    "America/Ojinaga (CDT) (-5:00)",
    "America/Panama (EST) (-5:00)",
    "America/Pangnirtung (EDT) (-4:00)",
    "America/Paramaribo (-03) (-3:00)",
    "America/Phoenix (MST) (-7:00)",
    "America/Port of Spain (AST) (-4:00)",
    "America/Port-au-Prince (EDT) (-4:00)",
    "America/Porto Acre (-05) (-5:00)",
    "America/Porto Velho (-04) (-4:00)",
    "America/Puerto Rico (AST) (-4:00)",
    "America/Punta Arenas (-03) (-3:00)",
    "America/Rainy River (CDT) (-5:00)",
    "America/Rankin Inlet (CDT) (-5:00)",
    "America/Recife (-03) (-3:00)",
    "America/Regina (CST) (-6:00)",
    "America/Resolute (CDT) (-5:00)",
    "America/Rio Branco (-05) (-5:00)",
    "America/Rosario (-03) (-3:00)",
    "America/Santa Isabel (PDT) (-7:00)",
    "America/Santarem (-03) (-3:00)",
    "America/Santiago (-04) (-4:00)",
    "America/Santo Domingo (AST) (-4:00)",
    "America/Sao Paulo (-03) (-3:00)",
    "America/Scoresbysund (-01) (-1:00)",
    "America/Shiprock (MDT) (-6:00)",
    "America/Sitka (AKDT) (-8:00)",
    "America/St Barthelemy (AST) (-4:00)",
    "America/St Johns (NDT) (-2:30)",
    "America/St Kitts (AST) (-4:00)",
    "America/St Lucia (AST) (-4:00)",
    "America/St Thomas (AST) (-4:00)",
    "America/St Vincent (AST) (-4:00)",
    "America/Swift Current (CST) (-6:00)",
    "America/Tegucigalpa (CST) (-6:00)",
    "America/Thule (ADT) (-3:00)",
    "America/Thunder Bay (EDT) (-4:00)",
    "America/Tijuana (PDT) (-7:00)",
    "America/Toronto (EDT) (-4:00)",
    "America/Tortola (AST) (-4:00)",
    "America/Vancouver (PDT) (-7:00)",
    "America/Virgin (AST) (-4:00)",
    "America/Whitehorse (MST) (-7:00)",
    "America/Winnipeg (CDT) (-5:00)",
    "America/Yakutat (AKDT) (-8:00)",
    "America/Yellowknife (MDT) (-6:00)",
    "Antarctica/Casey (+08) (+8:00)",
    "Antarctica/Davis (+07) (+7:00)",
    "Antarctica/DumontDUrville (+10) (+10:00)",
    "Antarctica/Macquarie (AEST) (+10:00)",
    "Antarctica/Mawson (+05) (+5:00)",
    "Antarctica/McMurdo (NZST) (+12:00)",
    "Antarctica/Palmer (-03) (-3:00)",
    "Antarctica/Rothera (-03) (-3:00)",
    "Antarctica/South Pole (NZST) (+12:00)",
    "Antarctica/Syowa (+03) (+3:00)",
    "Antarctica/Troll (+02) (+2:00)",
    "Antarctica/Vostok (+05) (+5:00)",
    "Arctic/Longyearbyen (CEST) (+2:00)",
    "Asia/Aden (+03) (+3:00)",
    "Asia/Almaty (+05) (+5:00)",
    "Asia/Amman (+03) (+3:00)",
    "Asia/Anadyr (+12) (+12:00)",
    "Asia/Aqtau (+05) (+5:00)",
    "Asia/Aqtobe (+05) (+5:00)",
    "Asia/Ashgabat (+05) (+5:00)",
    "Asia/Ashkhabad (+05) (+5:00)",
    "Asia/Atyrau (+05) (+5:00)",
    "Asia/Baghdad (+03) (+3:00)",
    "Asia/Bahrain (+03) (+3:00)",
    "Asia/Baku (+04) (+4:00)",
    "Asia/Bangkok (+07) (+7:00)",
    "Asia/Barnaul (+07) (+7:00)",
    "Asia/Beirut (EEST) (+3:00)",
    "Asia/Bishkek (+06) (+6:00)",
    "Asia/Brunei (+08) (+8:00)",
    "Asia/Calcutta (IST) (+5:30)",
    "Asia/Chita (+09) (+9:00)",
    "Asia/Choibalsan (+08) (+8:00)",
    "Asia/Chongqing (CST) (+8:00)",
    "Asia/Chungking (CST) (+8:00)",
    "Asia/Colombo (+0530) (+5:30)",
    "Asia/Dacca (+06) (+6:00)",
    "Asia/Damascus (+03) (+3:00)",
    "Asia/Dhaka (+06) (+6:00)",
    "Asia/Dili (+09) (+9:00)",
    "Asia/Dubai (+04) (+4:00)",
    "Asia/Dushanbe (+05) (+5:00)",
    "Asia/Famagusta (EEST) (+3:00)",
    "Asia/Gaza (EET) (+2:00)",
    "Asia/Harbin (CST) (+8:00)",
    "Asia/Hebron (EET) (+2:00)",
    "Asia/Ho Chi Minh (+07) (+7:00)",
    "Asia/Hong Kong (HKT) (+8:00)",
    "Asia/Hovd (+07) (+7:00)",
    "Asia/Irkutsk (+08) (+8:00)",
    "Asia/Istanbul (+03) (+3:00)",
    "Asia/Jakarta (WIB) (+7:00)",
    "Asia/Jayapura (WIT) (+9:00)",
    "Asia/Jerusalem (IDT) (+3:00)",
    "Asia/Kabul (+0430) (+4:30)",
    "Asia/Kamchatka (+12) (+12:00)",
    "Asia/Karachi (PKT) (+5:00)",
    "Asia/Kashgar (+06) (+6:00)",
    "Asia/Kathmandu (+0545) (+5:45)",
    "Asia/Katmandu (+0545) (+5:45)",
    "Asia/Khandyga (+09) (+9:00)",
    "Asia/Kolkata (IST) (+5:30)",
    "Asia/Krasnoyarsk (+07) (+7:00)",
    "Asia/Kuala Lumpur (+08) (+8:00)",
    "Asia/Kuching (+08) (+8:00)",
    "Asia/Kuwait (+03) (+3:00)",
    "Asia/Macao (CST) (+8:00)",
    "Asia/Macau (CST) (+8:00)",
    "Asia/Magadan (+11) (+11:00)",
    "Asia/Makassar (WITA) (+8:00)",
    "Asia/Manila (PST) (+8:00)",
    "Asia/Muscat (+04) (+4:00)",
    "Asia/Nicosia (EEST) (+3:00)",
    "Asia/Novokuznetsk (+07) (+7:00)",
    "Asia/Novosibirsk (+07) (+7:00)",
    "Asia/Omsk (+06) (+6:00)",
    "Asia/Oral (+05) (+5:00)",
    "Asia/Phnom Penh (+07) (+7:00)",
    "Asia/Pontianak (WIB) (+7:00)",
    "Asia/Pyongyang (KST) (+9:00)",
    "Asia/Qatar (+03) (+3:00)",
    "Asia/Qostanay (+05) (+5:00)",
    "Asia/Qyzylorda (+05) (+5:00)",
    "Asia/Rangoon (+0630) (+6:30)",
    "Asia/Riyadh (+03) (+3:00)",
    "Asia/Saigon (+07) (+7:00)",
    "Asia/Sakhalin (+11) (+11:00)",
    "Asia/Samarkand (+05) (+5:00)",
    "Asia/Seoul (KST) (+9:00)",
    "Asia/Shanghai (CST) (+8:00)",
    "Asia/Singapore (+08) (+8:00)",
    "Asia/Srednekolymsk (+11) (+11:00)",
    "Asia/Taipei (CST) (+8:00)",
    "Asia/Tashkent (+05) (+5:00)",
    "Asia/Tbilisi (+04) (+4:00)",
    "Asia/Tehran (+0330) (+3:30)",
    "Asia/Tel Aviv (IDT) (+3:00)",
    "Asia/Thimbu (+06) (+6:00)",
    "Asia/Thimphu (+06) (+6:00)",
    "Asia/Tokyo (JST) (+9:00)",
    "Asia/Tomsk (+07) (+7:00)",
    "Asia/Ujung Pandang (WITA) (+8:00)",
    "Asia/Ulaanbaatar (+08) (+8:00)",
    "Asia/Ulan Bator (+08) (+8:00)",
    "Asia/Urumqi (+06) (+6:00)",
    "Asia/Ust-Nera (+10) (+10:00)",
    "Asia/Vientiane (+07) (+7:00)",
    "Asia/Vladivostok (+10) (+10:00)",
    "Asia/Yakutsk (+09) (+9:00)",
    "Asia/Yangon (+0630) (+6:30)",
    "Asia/Yekaterinburg (+05) (+5:00)",
    "Asia/Yerevan (+04) (+4:00)",
    "Atlantic/Azores (+00) (+0:00)",
    "Atlantic/Bermuda (ADT) (-3:00)",
    "Atlantic/Canary (WEST) (+1:00)",
    "Atlantic/Cape Verde (-01) (-1:00)",
    "Atlantic/Faeroe (WEST) (+1:00)",
    "Atlantic/Faroe (WEST) (+1:00)",
    "Atlantic/Jan Mayen (CEST) (+2:00)",
    "Atlantic/Madeira (WEST) (+1:00)",
    "Atlantic/Reykjavik (GMT) (+0:00)",
    "Atlantic/South Georgia (-02) (-2:00)",
    "Atlantic/St Helena (GMT) (+0:00)",
    "Atlantic/Stanley (-03) (-3:00)",
    "Australia/ACT (AEST) (+10:00)",
    "Australia/Adelaide (ACST) (+9:30)",
    "Australia/Brisbane (AEST) (+10:00)",
    "Australia/Broken Hill (ACST) (+9:30)",
    "Australia/Canberra (AEST) (+10:00)",
    "Australia/Currie (AEST) (+10:00)",
    "Australia/Darwin (ACST) (+9:30)",
    "Australia/Eucla (+0845) (+8:45)",
    "Australia/Hobart (AEST) (+10:00)",
    "Australia/LHI (+1030) (+10:30)",
    "Australia/Lindeman (AEST) (+10:00)",
    "Australia/Lord Howe (+1030) (+10:30)",
    "Australia/Melbourne (AEST) (+10:00)",
    "Australia/NSW (AEST) (+10:00)",
    "Australia/North (ACST) (+9:30)",
    "Australia/Perth (AWST) (+8:00)",
    "Australia/Queensland (AEST) (+10:00)",
    "Australia/South (ACST) (+9:30)",
    "Australia/Sydney (AEST) (+10:00)",
    "Australia/Tasmania (AEST) (+10:00)",
    "Australia/Victoria (AEST) (+10:00)",
    "Australia/West (AWST) (+8:00)",
    "Australia/Yancowinna (ACST) (+9:30)",
    "Brazil/Acre (-05) (-5:00)",
    "Brazil/DeNoronha (-02) (-2:00)",
    "Brazil/East (-03) (-3:00)",
    "Brazil/West (-04) (-4:00)",
    "CET (CEST) (+2:00)",
    "CST6CDT (CDT) (-5:00)",
    "Canada/Atlantic (ADT) (-3:00)",
    "Canada/Central (CDT) (-5:00)",
    "Canada/Eastern (EDT) (-4:00)",
    "Canada/Mountain (MDT) (-6:00)",
    "Canada/Newfoundland (NDT) (-2:30)",
    "Canada/Pacific (PDT) (-7:00)",
    "Canada/Saskatchewan (CST) (-6:00)",
    "Canada/Yukon (MST) (-7:00)",
    "Chile/Continental (-04) (-4:00)",
    "Chile/EasterIsland (-06) (-6:00)",
    "Cuba (CDT) (-4:00)",
    "EET (EEST) (+3:00)",
    "EST (EST) (-5:00)",
    "EST5EDT (EDT) (-4:00)",
    "Egypt (EET) (+2:00)",
    "Eire (IST) (+1:00)",
    "Etc/GMT (GMT) (+0:00)",
    "Etc/GMT+0 (GMT) (+0:00)",
    "Etc/GMT+1 (-01) (-1:00)",
    "Etc/GMT+10 (-10) (-10:00)",
    "Etc/GMT+11 (-11) (-11:00)",
    "Etc/GMT+12 (-12) (-12:00)",
    "Etc/GMT+2 (-02) (-2:00)",
    "Etc/GMT+3 (-03) (-3:00)",
    "Etc/GMT+4 (-04) (-4:00)",
    "Etc/GMT+5 (-05) (-5:00)",
    "Etc/GMT+6 (-06) (-6:00)",
    "Etc/GMT+7 (-07) (-7:00)",
    "Etc/GMT+8 (-08) (-8:00)",
    "Etc/GMT+9 (-09) (-9:00)",
    "Etc/GMT-0 (GMT) (+0:00)",
    "Etc/GMT-1 (+01) (+1:00)",
    "Etc/GMT-10 (+10) (+10:00)",
    "Etc/GMT-11 (+11) (+11:00)",
    "Etc/GMT-12 (+12) (+12:00)",
    "Etc/GMT-13 (+13) (+13:00)",
    "Etc/GMT-14 (+14) (+14:00)",
    "Etc/GMT-2 (+02) (+2:00)",
    "Etc/GMT-3 (+03) (+3:00)",
    "Etc/GMT-4 (+04) (+4:00)",
    "Etc/GMT-5 (+05) (+5:00)",
    "Etc/GMT-6 (+06) (+6:00)",
    "Etc/GMT-7 (+07) (+7:00)",
    "Etc/GMT-8 (+08) (+8:00)",
    "Etc/GMT-9 (+09) (+9:00)",
    "Etc/GMT0 (GMT) (+0:00)",
    "Etc/Greenwich (GMT) (+0:00)",
    "Etc/UCT (UTC) (+0:00)",
    "Etc/UTC (UTC) (+0:00)",
    "Etc/Universal (UTC) (+0:00)",
    "Etc/Zulu (UTC) (+0:00)",
    "Europe/Amsterdam (CEST) (+2:00)",
    "Europe/Andorra (CEST) (+2:00)",
    "Europe/Astrakhan (+04) (+4:00)",
    "Europe/Athens (EEST) (+3:00)",
    "Europe/Belfast (BST) (+1:00)",
    "Europe/Belgrade (CEST) (+2:00)",
    "Europe/Berlin (CEST) (+2:00)",
    "Europe/Bratislava (CEST) (+2:00)",
    "Europe/Brussels (CEST) (+2:00)",
    "Europe/Bucharest (EEST) (+3:00)",
    "Europe/Budapest (CEST) (+2:00)",
    "Europe/Busingen (CEST) (+2:00)",
    "Europe/Chisinau (EEST) (+3:00)",
    "Europe/Copenhagen (CEST) (+2:00)",
    "Europe/Dublin (IST) (+1:00)",
    "Europe/Gibraltar (CEST) (+2:00)",
    "Europe/Guernsey (BST) (+1:00)",
    "Europe/Helsinki (EEST) (+3:00)",
    "Europe/Isle of Man (BST) (+1:00)",
    "Europe/Istanbul (+03) (+3:00)",
    "Europe/Jersey (BST) (+1:00)",
    "Europe/Kaliningrad (EET) (+2:00)",
    "Europe/Kiev (EEST) (+3:00)",
    "Europe/Kirov (MSK) (+3:00)",
    "Europe/Kyiv (EEST) (+3:00)",
    "Europe/Lisbon (WEST) (+1:00)",
    "Europe/Ljubljana (CEST) (+2:00)",
    "Europe/London (BST) (+1:00)",
    "Europe/Luxembourg (CEST) (+2:00)",
    "Europe/Madrid (CEST) (+2:00)",
    "Europe/Malta (CEST) (+2:00)",
    "Europe/Mariehamn (EEST) (+3:00)",
    "Europe/Minsk (+03) (+3:00)",
    "Europe/Monaco (CEST) (+2:00)",
    "Europe/Moscow (MSK) (+3:00)",
    "Europe/Nicosia (EEST) (+3:00)",
    "Europe/Oslo (CEST) (+2:00)",
    "Europe/Paris (CEST) (+2:00)",
    "Europe/Podgorica (CEST) (+2:00)",
    "Europe/Prague (CEST) (+2:00)",
    "Europe/Riga (EEST) (+3:00)",
    "Europe/Rome (CEST) (+2:00)",
    "Europe/Samara (+04) (+4:00)",
    "Europe/San Marino (CEST) (+2:00)",
    "Europe/Sarajevo (CEST) (+2:00)",
    "Europe/Saratov (+04) (+4:00)",
    "Europe/Simferopol (MSK) (+3:00)",
    "Europe/Skopje (CEST) (+2:00)",
    "Europe/Sofia (EEST) (+3:00)",
    "Europe/Stockholm (CEST) (+2:00)",
    "Europe/Tallinn (EEST) (+3:00)",
    "Europe/Tirane (CEST) (+2:00)",
    "Europe/Tiraspol (EEST) (+3:00)",
    "Europe/Ulyanovsk (+04) (+4:00)",
    "Europe/Uzhgorod (EEST) (+3:00)",
    "Europe/Vaduz (CEST) (+2:00)",
    "Europe/Vatican (CEST) (+2:00)",
    "Europe/Vienna (CEST) (+2:00)",
    "Europe/Vilnius (EEST) (+3:00)",
    "Europe/Volgograd (MSK) (+3:00)",
    "Europe/Warsaw (CEST) (+2:00)",
    "Europe/Zagreb (CEST) (+2:00)",
    "Europe/Zaporozhye (EEST) (+3:00)",
    "Europe/Zurich (CEST) (+2:00)",
    "GB (BST) (+1:00)",
    "GB-Eire (BST) (+1:00)",
    "GMT (GMT) (+0:00)",
    "GMT+0 (GMT) (+0:00)",
    "GMT-0 (GMT) (+0:00)",
    "GMT0 (GMT) (+0:00)",
    "Greenwich (GMT) (+0:00)",
    "HST (HST) (-10:00)",
    "Hongkong (HKT) (+8:00)",
    "Iceland (GMT) (+0:00)",
    "Indian/Antananarivo (EAT) (+3:00)",
    "Indian/Chagos (+06) (+6:00)",
    "Indian/Christmas (+07) (+7:00)",
    "Indian/Cocos (+0630) (+6:30)",
    "Indian/Comoro (EAT) (+3:00)",
    "Indian/Kerguelen (+05) (+5:00)",
    "Indian/Mahe (+04) (+4:00)",
    "Indian/Maldives (+05) (+5:00)",
    "Indian/Mauritius (+04) (+4:00)",
    "Indian/Mayotte (EAT) (+3:00)",
    "Indian/Reunion (+04) (+4:00)",
    "Iran (+0330) (+3:30)",
    "Israel (IDT) (+3:00)",
    "Jamaica (EST) (-5:00)",
    "Japan (JST) (+9:00)",
    "Kwajalein (+12) (+12:00)",
    "Libya (EET) (+2:00)",
    "MET (CEST) (+2:00)",
    "MST (MST) (-7:00)",
    "MST7MDT (MDT) (-6:00)",
    "Mexico/BajaNorte (PDT) (-7:00)",
    "Mexico/BajaSur (MST) (-7:00)",
    "Mexico/General (CST) (-6:00)",
    "NZ (NZST) (+12:00)",
    "NZ-CHAT (+1245) (+12:45)",
    "Navajo (MDT) (-6:00)",
    "PRC (CST) (+8:00)",
    "PST8PDT (PDT) (-7:00)",
    "Pacific/Apia (+13) (+13:00)",
    "Pacific/Auckland (NZST) (+12:00)",
    "Pacific/Bougainville (+11) (+11:00)",
    "Pacific/Chatham (+1245) (+12:45)",
    "Pacific/Chuuk (+10) (+10:00)",
    "Pacific/Easter (-06) (-6:00)",
    "Pacific/Efate (+11) (+11:00)",
    "Pacific/Enderbury (+13) (+13:00)",
    "Pacific/Fakaofo (+13) (+13:00)",
    "Pacific/Fiji (+12) (+12:00)",
    "Pacific/Funafuti (+12) (+12:00)",
    "Pacific/Galapagos (-06) (-6:00)",
    "Pacific/Gambier (-09) (-9:00)",
    "Pacific/Guadalcanal (+11) (+11:00)",
    "Pacific/Guam (ChST) (+10:00)",
    "Pacific/Honolulu (HST) (-10:00)",
    "Pacific/Johnston (HST) (-10:00)",
    "Pacific/Kanton (+13) (+13:00)",
    "Pacific/Kiritimati (+14) (+14:00)",
    "Pacific/Kosrae (+11) (+11:00)",
    "Pacific/Kwajalein (+12) (+12:00)",
    "Pacific/Majuro (+12) (+12:00)",
    "Pacific/Marquesas (-0930) (-9:30)",
    "Pacific/Midway (SST) (-11:00)",
    "Pacific/Nauru (+12) (+12:00)",
    "Pacific/Niue (-11) (-11:00)",
    "Pacific/Norfolk (+11) (+11:00)",
    "Pacific/Noumea (+11) (+11:00)",
    "Pacific/Pago Pago (SST) (-11:00)",
    "Pacific/Palau (+09) (+9:00)",
    "Pacific/Pitcairn (-08) (-8:00)",
    "Pacific/Pohnpei (+11) (+11:00)",
    "Pacific/Ponape (+11) (+11:00)",
    "Pacific/Port Moresby (+10) (+10:00)",
    "Pacific/Rarotonga (-10) (-10:00)",
    "Pacific/Saipan (ChST) (+10:00)",
    "Pacific/Samoa (SST) (-11:00)",
    "Pacific/Tahiti (-10) (-10:00)",
    "Pacific/Tarawa (+12) (+12:00)",
    "Pacific/Tongatapu (+13) (+13:00)",
    "Pacific/Truk (+10) (+10:00)",
    "Pacific/Wake (+12) (+12:00)",
    "Pacific/Wallis (+12) (+12:00)",
    "Pacific/Yap (+10) (+10:00)",
    "Poland (CEST) (+2:00)",
    "Portugal (WEST) (+1:00)",
    "ROC (CST) (+8:00)",
    "ROK (KST) (+9:00)",
    "Singapore (+08) (+8:00)",
    "Turkey (+03) (+3:00)",
    "UCT (UTC) (+0:00)",
    "US/Alaska (AKDT) (-8:00)",
    "US/Aleutian (HDT) (-9:00)",
    "US/Arizona (MST) (-7:00)",
    "US/Central (CDT) (-5:00)",
    "US/East-Indiana (EDT) (-4:00)",
    "US/Eastern (EDT) (-4:00)",
    "US/Hawaii (HST) (-10:00)",
    "US/Indiana-Starke (CDT) (-5:00)",
    "US/Michigan (EDT) (-4:00)",
    "US/Mountain (MDT) (-6:00)",
    "US/Pacific (PDT) (-7:00)",
    "US/Samoa (SST) (-11:00)",
    "UTC (UTC) (+0:00)",
    "Universal (UTC) (+0:00)",
    "W-SU (MSK) (+3:00)",
    "WET (WEST) (+1:00)",
    "Zulu (UTC) (+0:00)",
  ];
  

export const candidateTimeZoneList = [
    "(GMT-12:00) International Date Line West",
    "(GMT-11:00) Midway Island, Samoa",
    "(GMT-10:00) Hawaii",
    "(GMT-09:00) Alaska",
    "(GMT-08:00) Pacific Time (US & Canada)",
    "(GMT-08:00) Tijuana, Baja California",
    "(GMT-07:00) Arizona",
    "(GMT-07:00) Chihuahua, La Paz, Mazatlan",
    "(GMT-07:00) Mountain Time (US & Canada)",
    "(GMT-06:00) Central America",
    "(GMT-06:00) Central Time (US & Canada)",
    "(GMT-05:00) Bogota, Lima, Quito, Rio Branco",
    "(GMT-05:00) Eastern Time (US & Canada)",
    "(GMT-05:00) Indiana (East)",
    "(GMT-04:00) Atlantic Time (Canada)",
    "(GMT-04:00) Caracas, La Paz",
    "(GMT-04:00) Manaus",
    "(GMT-04:00) Santiago",
    "(GMT-03:30) Newfoundland",
    "(GMT-03:00) Brasilia",
    "(GMT-03:00) Buenos Aires, Georgetown",
    "(GMT-03:00) Greenland",
    "(GMT-03:00) Montevideo",
    "(GMT-02:00) Mid-Atlantic",
    "(GMT-01:00) Cape Verde Is.",
    "(GMT-01:00) Azores",
    "(GMT+00:00) Casablanca, Monrovia, Reykjavik",
    "(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London",
    "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris",
    "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
    "(GMT+01:00) West Central Africa",
    "(GMT+02:00) Amman",
    "(GMT+02:00) Athens, Bucharest, Istanbul",
    "(GMT+02:00) Beirut",
    "(GMT+02:00) Cairo",
    "(GMT+02:00) Harare, Pretoria",
    "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    "(GMT+02:00) Jerusalem",
    "(GMT+02:00) Minsk",
    "(GMT+02:00) Windhoek",
    "(GMT+03:00) Kuwait, Riyadh, Baghdad",
    "(GMT+03:00) Moscow, St. Petersburg, Volgograd",
    "(GMT+03:00) Nairobi",
    "(GMT+03:00) Tbilisi",
    "(GMT+03:30) Tehran",
    "(GMT+04:00) Abu Dhabi, Muscat",
    "(GMT+04:00) Baku",
    "(GMT+04:00) Yerevan",
    "(GMT+04:30) Kabul",
    "(GMT+05:00) Yekaterinburg",
    "(GMT+05:00) Islamabad, Karachi, Tashkent",
    "(GMT+05:30) Sri Jayawardenapura",
    "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi",
    "(GMT+05:45) Kathmandu",
    "(GMT+06:00) Almaty, Novosibirsk",
    "(GMT+06:00) Astana, Dhaka",
    "(GMT+06:30) Yangon (Rangoon)",
    "(GMT+07:00) Bangkok, Hanoi, Jakarta",
    "(GMT+07:00) Krasnoyarsk",
    "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
    "(GMT+08:00) Kuala Lumpur, Singapore",
    "(GMT+08:00) Irkutsk, Ulaan Bataar",
    "(GMT+08:00) Perth",
    "(GMT+08:00) Taipei",
    "(GMT+09:00) Osaka, Sapporo, Tokyo",
    "(GMT+09:00) Seoul",
    "(GMT+09:00) Yakutsk",
    "(GMT+09:30) Adelaide",
    "(GMT+09:30) Darwin",
    "(GMT+10:00) Brisbane",
    "(GMT+10:00) Canberra, Melbourne, Sydney",
    "(GMT+10:00) Hobart",
    "(GMT+10:00) Guam, Port Moresby",
    "(GMT+10:00) Vladivostok",
    "(GMT+11:00) Magadan, Solomon Is., New Caledonia",
    "(GMT+12:00) Auckland, Wellington",
    "(GMT+12:00) Fiji, Kamchatka, Marshall Is.",
    "(GMT+13:00) Nuku'alofa"
]